import { useContext, useState } from "react"
import Loader from "../Loader";
import SystemModal from "../SystemModal";
import SchoolContext from "../../../Context/SchoolContext";
import Select from "react-select";
import ajaxStudent from "../../../util/remote/ajaxStudent";


const ActivationsFilterForm=(props)=>{

    const [loading, setLoading] = useState(false)
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [query, setQuery] = useState("");

    const [role, setRole] = useState("");

    const {schoolList} = useContext(SchoolContext);
    const [school, setSchool] = useState("");

    const handleSearch = async(e) =>{
        e.preventDefault()
        setLoading(true)
        const server_response = await ajaxStudent.searchAllActivations(props.page, school, query, startDate, endDate, role);
        setLoading(false);
        if(server_response.status==="OK"){
            props.h(server_response.details.meta.totalPages);
            props.g(server_response.details.data || []);
        }
        else{
            props.g([])
        } 
    }
    

    const RenderFooter=(controls)=>{

        if(loading){
            return <Loader/>
        }else{

            return <> 
                    <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
                    <button 
                        type="button" 
                        className={`btn-fill-md text-light bg-dodger-blue`} 
                        onClick={handleSearch}>Filter<i class="fas fa-check mg-l-15"></i></button>
                    </>
        }
    }

    return(
        <SystemModal
            title="Filter Account Activations"
            id="model-activations-filter"
            size="md"
            footer={RenderFooter}
        >

            <div className="row">
                <div className="col-lg-12">
                    <div className="mb-4 form-group border-1">
                        <label htmlFor="">Student Name</label>
                        <input  onChange={(e) => setQuery(e.target.value)} placeholder="Enter student name..."  style={{border: "1px solid grey"}} value={query} type="text" className="form-control"/>
                    </div>
                </div>
               
            </div>
            <div className="row">
                <div className="col-lg-6">
                    <div className="mb-4 form-group border-1">
                <label htmlFor="">School</label>
                <Select
                      onChange={(e) => setSchool(e.school_id)}
                      getOptionLabel={(option) => option.school_name}
                      getOptionValue={(option) => option.school_id}
                      isSearchable
                      options={Array.isArray(schoolList) ? schoolList : []}
                      value={
                        Array.isArray(schoolList) &&
                        schoolList.find((value) => value.school_id === school)
                      }
                    />
            </div>
                </div>
                <div className="col-lg-6">
                    <div className="mb-4 form-group border-1">
                <label htmlFor="">Activated By</label>

                    <select
                        style={{border: "1px solid grey"}}
                        className="col-12 form-control"
                        value={role}
                        onChange={(e) => setRole(e.target.value)}>
                        <option value="" selected disabled>Select...</option>
                        <option value="2">Admins</option>
                        <option value="3">School Admins</option>
                        <option value="1">Super Admins</option>
                        <option value="7">Vendors</option>
                        <option value="4">Parents</option>
                        <option value="NULL">Others</option>

                </select>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-6">
                    <div className="mb-4 form-group border-1">
                        <label htmlFor="">Start Date</label>
                        <input  onChange={(e) => setStartDate(e.target.value)}  style={{border: "1px solid grey"}} value={startDate} type="date" className="form-control"/>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="mb-4 form-group border-1">
                        <label htmlFor="">End Date</label>
                        <input onChange={(e) => setEndDate(e.target.value)}  style={{border: "1px solid grey"}} value={endDate} type="date" className="form-control"/>
                    </div>
                </div>
            </div>
        
       
        </SystemModal>
    )
}

export default ActivationsFilterForm
